import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { CosmosComponent } from '../../../types';

export const ApolloLogo: FC<CosmosComponent> = ({ className, isInverted }) => (
  <StyledSvg
    className={className}
    isInverted={isInverted}
    viewBox="0 0 94 55"
    role="img"
    aria-label="Apollo UK logo"
  >
    <path
      d="M19.1214 32.8367V49.8928H14.583L14.0802 48.6865C12.6844 49.818 10.9169 50.4698 8.9372 50.4698C3.72556 50.47 0 46.6651 0 41.3646C0 36.0642 3.72556 32.3228 8.9372 32.3228C10.9447 32.3228 12.7378 32.9937 14.1452 34.1557L14.7458 32.8367H19.1214ZM13.5376 41.3784C13.5376 39.1647 11.9212 37.5018 9.72231 37.5018C7.52342 37.5018 5.90697 39.1645 5.90697 41.3784C5.90697 43.5924 7.52342 45.2685 9.72231 45.2685C11.9212 45.2685 13.5376 43.6059 13.5376 41.3784Z"
      fill="#F58229"
    />
    <path
      d="M39.2731 41.3828C39.2731 46.6968 35.5475 50.488 30.3359 50.488C28.7947 50.488 27.3836 50.0823 26.1809 49.3553V55H20.377V32.8546H24.3694L25.1048 34.2096C26.5065 32.9966 28.3104 32.2954 30.3359 32.2954C35.5475 32.2954 39.2731 36.0686 39.2731 41.3823V41.3828ZM33.3659 41.3828C33.3659 39.142 31.7494 37.4794 29.5505 37.4794C27.3516 37.4794 25.7352 39.142 25.7352 41.3828C25.7352 43.6236 27.3516 45.2862 29.5505 45.2862C31.7494 45.2862 33.3659 43.6236 33.3659 41.3828Z"
      fill="#F58229"
    />
    <path d="M60.376 28.0864H66.2468V49.9109H60.376V28.0864Z" fill="#F58229" />
    <path
      d="M67.4141 28.0864H73.2849V49.9109H67.4141V28.0864Z"
      fill="#F58229"
    />
    <path
      d="M74.3359 41.3826C74.3359 36.0954 78.335 32.2959 83.892 32.2959C89.4489 32.2959 93.448 36.0954 93.448 41.3826C93.448 46.6697 89.431 50.4697 83.892 50.4697C78.353 50.4697 74.3359 46.6517 74.3359 41.3826ZM83.892 45.1924C86.0326 45.1924 87.5678 43.6381 87.5678 41.3833C87.5678 39.1285 86.0326 37.5739 83.892 37.5739C81.7514 37.5739 80.2161 39.1283 80.2161 41.3831C80.2161 43.6379 81.7514 45.1922 83.892 45.1922V45.1924Z"
      fill="#F58229"
    />
    <path
      d="M40.2822 41.3826C40.2822 36.0954 44.2813 32.2959 49.8383 32.2959C55.3952 32.2959 59.3943 36.0954 59.3943 41.3826C59.3943 46.6697 55.3773 50.4697 49.8383 50.4697C44.2992 50.4697 40.2822 46.6517 40.2822 41.3826ZM49.8383 45.1924C51.9789 45.1924 53.5141 43.6381 53.5141 41.3833C53.5141 39.1285 51.9789 37.5739 49.8383 37.5739C47.6977 37.5739 46.1624 39.1283 46.1624 41.3831C46.1624 43.6379 47.6977 45.1922 49.8383 45.1922V45.1924Z"
      fill="#F58229"
    />
    <path
      d="M8.75687 15.604C12.1816 15.5329 15.629 15.0805 19.1681 14.2163C22.7062 13.3576 26.3334 12.0826 30.0791 10.5234C33.8268 8.96586 37.6926 7.13907 41.7278 5.33247C45.7645 3.52784 49.9837 1.75963 54.3657 0.359881C54.6237 0.277181 54.8825 0.196204 55.1415 0.116211H0.83499C0.468264 0.116211 0.170898 0.413784 0.170898 0.780765V15.0534C3.03461 15.4625 5.89094 15.6658 8.75687 15.604Z"
      fill="#006940"
    />
    <path
      d="M93.3355 0.115723H90.7549C89.6982 0.159042 88.6455 0.220082 87.5975 0.300813C85.4802 0.478766 83.3844 0.736712 81.322 1.08843L80.5502 1.22577C80.2934 1.27254 80.0367 1.31389 79.7818 1.37001L78.2557 1.68801L76.7455 2.04711C76.2449 2.17387 75.7481 2.31294 75.2522 2.44437C73.2728 2.99866 71.342 3.65337 69.469 4.40776C65.7191 5.91531 62.2159 7.82086 58.8966 10.0363C55.5727 12.2527 52.4203 14.7664 49.2272 17.4441C46.1016 20.0649 42.9245 22.8457 39.4678 25.6102H93.3355C93.7022 25.6102 93.9996 25.3127 93.9996 24.9457V0.780277C93.9996 0.413295 93.7022 0.115723 93.3355 0.115723Z"
      fill="#006940"
    />
    <path
      d="M64.4838 1.28174C63.0051 1.81117 61.5003 2.40164 59.9443 3.06299L60.8559 3.2818C62.3715 2.60051 63.8477 1.99207 65.294 1.45206L64.4838 1.28174Z"
      fill="#006940"
    />
    <path
      d="M66.5451 1.00323C67.3228 0.731256 68.1079 0.467896 68.8992 0.226933L69.6447 0H68.406L68.39 0.00467649C67.4987 0.26656 66.6206 0.54838 65.7637 0.839061L66.5448 1.00323H66.5451Z"
      fill="#006940"
    />
    <path
      d="M58.1808 3.83301C56.3044 4.67404 54.3421 5.61992 52.2505 6.69059L53.373 7.0556C55.3757 5.94654 57.2991 4.95167 59.1573 4.06732L58.1808 3.83301Z"
      fill="#006940"
    />
    <path
      d="M39.9133 12.9734C38.9526 13.4093 38.0098 13.8506 37.207 14.2831C35.1567 15.3874 32.9713 16.465 30.8578 17.5069L30.3666 17.7491C30.3159 17.7739 30.2672 17.7976 30.2168 17.8222L33.1004 19.0511C35.1931 17.8852 37.1644 16.7257 38.9644 15.6469C40.0326 15.0062 41.1079 14.3522 42.1673 13.7059L39.9135 12.9731L39.9133 12.9734Z"
      fill="#006940"
    />
    <path
      d="M27.1473 19.2896C25.8959 19.8704 24.7064 20.3998 23.563 20.8837C21.2918 21.8461 18.9458 22.7366 16.59 23.5306C14.3045 24.2949 12.0247 24.9567 9.81404 25.498L8.87939 25.7269H18.9785L18.9984 25.7195C21.2025 24.8866 23.4274 23.9414 25.6116 22.9109C27.1955 22.1703 28.7362 21.3927 30.2324 20.6049L27.1471 19.29L27.1473 19.2896Z"
      fill="#006940"
    />
    <path
      d="M44.5146 12.273C44.8176 12.0879 45.1207 11.9026 45.4239 11.718C47.3163 10.5702 49.3514 9.34796 51.4524 8.1397L50.2258 7.74072C48.3149 8.74518 46.4434 9.76638 44.8147 10.6616C44.1895 11.0039 43.4776 11.3502 42.7368 11.6948L44.5149 12.273H44.5146Z"
      fill="#006940"
    />
    <path
      d="M93.1461 29.5838C93.1461 31.1027 91.9402 32.3225 90.4238 32.3225C88.9075 32.3225 87.687 31.0882 87.687 29.5838C87.687 28.0794 88.9062 26.8594 90.4238 26.8594C91.9414 26.8594 93.1461 28.0664 93.1461 29.5838ZM92.6342 29.5838C92.6342 28.363 91.6438 27.3849 90.424 27.3849C89.2043 27.3849 88.1991 28.3618 88.1991 29.5838C88.1991 30.8058 89.1898 31.797 90.424 31.797C91.6583 31.797 92.6342 30.8189 92.6342 29.5838ZM91.004 29.8868L91.6406 30.9678H91.0877L90.4969 29.9459H90.0071V30.9678H89.482V28.1422H90.639C91.175 28.1422 91.5712 28.5363 91.5712 29.0701C91.5712 29.4743 91.3454 29.7672 91.004 29.8868ZM90.0071 29.473H90.5994C90.8793 29.473 91.0589 29.3089 91.0589 29.0573C91.0589 28.8058 90.8793 28.6288 90.5994 28.6288H90.0071V29.473Z"
      fill="#F58229"
    />
    <defs>
      <clipPath id="clip0_5630_76753">
        <rect width="94" height="55" fill="white" />
      </clipPath>
    </defs>
  </StyledSvg>
);

const StyledSvg = styled.svg<{ isInverted?: boolean }>`
  width: 100%;
  fill: #231f20;

  ${({ isInverted }) =>
    isInverted &&
    css`
      fill: ${({ theme: { colors } }) => colors?.white};
    `}
`;
